import { formatDate } from '../helper';
import FormConfig from '../../public/form_config.json';

export default {
  methods: {
    mapPropertiesToInvoiceObject(inputFields, vats, paymentProcessing) {
      const mappedObject = {};
      Object.keys(inputFields).map((key) => {
        if (['inv_date', 'pay_until', 'service_provided_at'].includes(key)) {
          mappedObject[key] = formatDate(inputFields[key].model).trim() || '';
        } else if (!paymentProcessing && ['prepaid_amount', 'purpose_code', 'iban'].includes(key)) {
          if (key === 'prepaid_amount') {
            mappedObject[key] = inputFields.gross.model || '';
          } else {
            mappedObject[key] = '';
          }
        } else {
          mappedObject[key] = inputFields[key].model || '';
        }
      });
      mappedObject.vats = vats;
      mappedObject.products = [];
      return mappedObject;
    },
    mapDefaultValuesToInvoiceObject() {
      return {
        currency: 'EUR',
        gross: '0.00',
        iban: '',
        inv_date: '01.01.1990',
        inv_num: '',
        net: '0.00',
        pay_until: '01.01.1990',
        products: [],
        purpose_code: '',
        received_at: '01.01.1990',
        reference: '',
        seller_name: '',
        service_provided_at: '01.01.1990',
        vat: '0.00  ',
        vat_id_publisher: '',
        vats: [],
        prepaid_amount: '0.00',
      };
    },
    mapV1(detectedData, inputFields) {
      Object.keys(inputFields).map((key) => {
        // Don't copy fields that don't yet exist
        if (detectedData[key]) {
          // Don't copy default dates
          if (['inv_date', 'pay_until', 'service_provided_at', 'received_at'].includes(key)) {
            if (detectedData.hasOwnProperty(key) && detectedData[key]['found'] === false) {
              return;
            }
          }
          if (key === 'received_at') {
            detectedData[key] = detectedData.inv_date;
          }
          if (key === 'prepaid_amount') {
            inputFields[key].items = [detectedData.gross || '0.00'];
            [inputFields[key].model] = '0.00';
            inputFields[key].validated = false;
          } else if (detectedData[key].hasOwnProperty('value')) {
            inputFields[key].items = detectedData[key].value;
            // Array destructuring for the first element
            [inputFields[key].model] = detectedData[key].value;
            inputFields[key].validated = detectedData[key].validated;
          } else {
            inputFields[key].items = [detectedData[key]];
            inputFields[key].model = detectedData[key];
            inputFields[key].validated = true;
          }
        }
      });
      return inputFields;
    },
    mapV2(detectedData, inputFields) {
      const data = detectedData['keys'] || detectedData;
      data['received_at'] = data['inv_date'];
      for (let [key, value] of Object.entries(inputFields)) {
        let detectedValue = data[key];
        if (detectedValue) {
          // Dates should be dd.mm.yyy
          if (['inv_date', 'pay_until', 'service_provided_at'].includes(key)) {
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            if (dateRegex.test(detectedValue)) {
              const [year, month, day] = detectedValue.split('-');
              detectedValue = `${day}.${month}.${year}`;
            }
          }
          // Iban values are packed in a list
          if (key === 'iban') {
            inputFields[key].items = detectedValue;
            inputFields[key].model = detectedValue[0];
            inputFields[key].validated = true;
            continue;
          }
          inputFields[key].items = [detectedValue];
          inputFields[key].model = detectedValue;
          inputFields[key].validated = true;
        }
      }
      return inputFields;
    },
    mapDataToInputFields(data, typlessVersion = 1) {
      const inputFields = this._.cloneDeep(FormConfig);
      const dataCopy = this._.cloneDeep(data);

      if (typlessVersion === 2) {
        return this.mapV2(dataCopy, inputFields);
      }
      return this.mapV1(dataCopy, inputFields);
    },
    mapVatValuesToValue(vats, typlessVersion = 1) {
      const vatsList = [];
      vats.forEach((vat) => {
        const vatObject = {};

        // Sanitize input values - convert empty strings/null/undefined to "0.00"
        const sanitizeValue = (value) => {
          if (
            value === '' ||
            value === null ||
            value === undefined ||
            Number.isNaN(parseFloat(value))
          ) {
            return '0.00';
          }
          return String(value);
        };

        const sanitizedVat = sanitizeValue(vat.vat);
        const sanitizedNet = sanitizeValue(vat.net);
        let sanitizedGross = sanitizeValue(vat.gross);
        const sanitizedPercentage = sanitizeValue(vat.percentage);

        if (typlessVersion === 2) {
          const gross = parseFloat(sanitizedVat) + parseFloat(sanitizedNet);
          sanitizedGross = String(gross);
        }

        vatObject.gross = {
          found: true,
          validated: true,
          value: [sanitizedGross],
        };
        vatObject.net = {
          found: true,
          validated: true,
          value: [sanitizedNet],
        };
        vatObject.vat = {
          found: true,
          validated: true,
          value: [sanitizedVat],
          percentage: sanitizedPercentage,
        };
        vatsList.push(vatObject);
      });
      return vatsList;
    },
    generateVatObjectArray(vats) {
      const clonedVats = this._.cloneDeep(vats);
      const nonEmptyVats = clonedVats.filter((vatObject) => {
        const [gross] = vatObject.gross.value;
        const grossNum = parseFloat(gross);
        const hasValidGross = !Number.isNaN(grossNum) && grossNum !== 0;
        return hasValidGross;
      });

      return nonEmptyVats.map((vatObject) => {
        const object = {};
        [object.vat] = vatObject.vat.value;
        object.percentage = vatObject.vat.percentage;
        [object.net] = vatObject.net.value;
        [object.gross] = vatObject.gross.value;

        // Ensure all values are valid numbers, default to "0.00" if not
        object.vat = object.vat && !Number.isNaN(parseFloat(object.vat)) ? object.vat : '0.00';
        object.net = object.net && !Number.isNaN(parseFloat(object.net)) ? object.net : '0.00';
        object.gross =
          object.gross && !Number.isNaN(parseFloat(object.gross)) ? object.gross : '0.00';
        object.percentage =
          object.percentage && !Number.isNaN(parseFloat(object.percentage))
            ? object.percentage
            : '0.00';

        return object;
      });
    },
  },
};
